import { defineNuxtPlugin, useRuntimeConfig, useHead } from '#app'

import {
  DEFAULT_FAVICON_PATH,
  buildFaviconLinks,
} from '@baserow/modules/core/head'

/**
 * Applies the per-deployment favicon path.
 *
 * The favicon `<link>` tags in `core/head.js` are merged into Nuxt's static
 * `app.head` by `core/module.js`, which is resolved when the app is *built*. The
 * production image is built once and shared by several deployments (see
 * `web-frontend/Dockerfile`), so the path cannot be baked in and has to be
 * re-applied here, at runtime, from the public runtime config.
 *
 * A plugin-level `useHead` outranks the static `app.head` defaults, so reusing
 * the same `key` for each link replaces the default rather than appending to it.
 * It is still lower priority than the component-level `useHead` in the
 * application builder's `PublicPageContent.vue`, so a published app's custom
 * favicon keeps winning over the deployment-wide one.
 *
 * When the path is unset or equal to the default, nothing is registered at all,
 * so deployments that do not set `BASEROW_FAVICON_PATH` keep the exact head
 * output they had before this plugin existed.
 */
export default defineNuxtPlugin(() => {
  const path = useRuntimeConfig().public.baserowFaviconPath

  if (!path || path === DEFAULT_FAVICON_PATH) {
    return
  }

  // Tolerate a configured trailing slash so `/img/brand/` and `/img/brand`
  // both resolve to the same URLs.
  useHead({ link: buildFaviconLinks(path.replace(/\/+$/, '')) })
})
